import { MeiliSearch } from "meilisearch";

export type SearchConfig = {
  host: string;
  apiKey: string;
};

export function getClient({ host, apiKey }: SearchConfig) {
  return new MeiliSearch({ host, apiKey });
}

export function getIndex(config: SearchConfig, site: number) {
  return getClient(config).index(site === 1 ? "1-site" : "2-site");
}
